import { Divider as CkDivider } from "@chakra-ui/react";
import React from "react";

const Divider = (props) => (
  <CkDivider borderColor="background.grey.500" {...props} />
);

export default Divider;
